import { generateLocale } from './generate.js';

export default generateLocale([
  'Nama Panggilan',
  'Nama Panggilan tidak boleh kurang dari 3 bita.',
  'E-Mail',
  'Silakan konfirmasi alamat email Anda.',
  'Situs Web',
  'Opsional',
  'Tulis komentar di sini...',
  'Belum ada komentar.',
  'Kirim',
  'Suka',
  'Batal suka',
  'Balas',
  'Batal balas',
  'Komentar',
  'Segarkan',
  'Muat Lebih Banyak...',
  'Pratinjau',
  'Emoji',
  'Unggah Gambar',
  'detik yang lalu',
  'menit yang lalu',
  'jam yang lalu',
  'hari yang lalu',
  'baru saja',
  'Mengunggah',
  'Masuk',
  'Keluar',
  'Admin',
  'Sematkan',
  'Kata',
  'Silakan masukkan komentar antara $0 dan $1 kata!\n Jumlah kata saat ini: $2',
  'Anonim',
  'Kurcaci',
  'Hobbit',
  'Ent',
  'Penyihir',
  'Peri',
  'Maiar',
  'GIF',
  'Cari GIF',
  'Profil',
  'Disetujui',
  'Menunggu',
  'Spam',
  'Lepas Sematan',
  'Terlama',
  'Terbaru',
  'Terpopuler',
  'Apa yang Anda pikirkan?',
  'Komentar Anda sedang ditinjau dan saat ini hanya terlihat oleh Anda. Komentar akan terlihat secara publik setelah disetujui.',
  'Berlangganan komentar di postingan ini',
  'Berlangganan komentar di situs ini',
  'Berlangganan balasan komentar Anda',
]);
